<template>
  <div class="primarylists nqt__priList">
    <ul class="container">
      <!-- KHOÁ HỌC ĐƯỢC NHIỀU HỌC VIÊN LỰA CHỌN -->
      <li v-if="data.listCouseHot.length > 0" id="desktop">
        <div class="lessons lessons-new">
          <div class="titles clear">
            <img src="../../../static/images/icon-st.jpg" alt="" />
            <div class="title l">
              <span style="text-transform: uppercase!important;"
                >{{ $t("new.title118") }}
              </span>
              <span
                class="title_more_catalog"
                v-if="
                  mobile
                    ? data.listCouseHot.length > 4
                    : data.listCouseHot.length >= 10
                "
                @click="nextPageSelfCourse(2)"
              >
                <span class="name_more_catalog">{{ $t("new.title3") }}</span>
                <span
                  ><img
                    class="icon_more_catalog"
                    style="height: auto!important;width: 17px!important;cursor: pointer;"
                    src="../../../static/images/dbright.png"
                    alt=""
                /></span>
              </span>
            </div>
          </div>
          <ul class="clear">
            <li
              v-for="(item, index) in data.listCouseHot"
              :key="index"
              @click="nextPageDetailsCourse(item)"
              :class="{ disabledCourse: mobile ? index > 3 : index > 9 }"
            >
              <div>
                <!-- Ảnh -->
                <div class="img vaa">
                  <template
                    v-if="item.courseCover == null || item.courseCover == ''"
                  >
                    <img src="../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="item.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="item.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img :src="item.courseCover" alt="/" />
                    </template>
                  </template>
                </div>
                <!-- Tên khoá học -->
                <div class="lessontitle_PC">
                  <div
                    class="lessontitle"
                    style="-webkit-box-orient: vertical;"
                  >
                    {{ item.courseName }}
                  </div>
                </div>
                <div class="lessontitle_MB">
                  <div
                    class="lessontitle"
                    style="-webkit-box-orient: vertical;"
                  >
                    {{ item.courseName }}
                  </div>
                </div>
                <div class="startAndPrice">
                  <!-- Giá tiền -->
                  <div>
                    <span
                      v-if="item.offSelf == 100 || item.coursePrice == 0"
                      class="priceIndex"
                    >
                      <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                    </span>
                    <span v-else class="priceIndex">
                      <template
                        v-if="
                          (item.offSelf > 0 && item.offSelf != null) ||
                            item.offSelf != ''
                        "
                      >
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          (item.coursePrice - item.coursePriceDiscount)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        <del class="price-orin"
                          ><span v-if="beforCurren">{{
                            $t("new.title121")
                          }}</span>
                          {{
                            item.coursePrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                          <span v-if="afterCurren">{{
                            $t("new.title121")
                          }}</span></del
                        >
                      </template>
                      <template v-else>
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                    </span>
                  </div>
                </div>
                <!-- Sao đánh giá -->
                <div class="startIndex">
                  <div
                    class="Stars"
                    :style="'--rating:' + item.courseEvaluate"
                  ></div>
                </div>
                <!-- {{ $t("new.title183") }} -->
                <div>
                  <p
                    class="button-sub"
                    @click.stop="clickNextPageSubsribe(item)"
                  >
                    {{ $t("new.title183") }}
                  </p>
                </div>
                <div class="borderIndex"></div>
                <div
                  v-if="
                    (item.offSelf > 0 && item.offSelf != null) ||
                      item.offSelf != ''
                  "
                  class="hot-position"
                >
                  <div class="">
                    <span>-{{ item.offSelf }}%</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </li>
      <!-- Swiper Hot-->
      <div v-if="data.listCouseHot.length > 0" id="mobile">
        <div class="mb-title-item" style="text-transform: uppercase!important;">
          {{ $t("new.title118") }}
        </div>
        <swiper class="swiper" :options="swiperOption">
          <li
            class="swiper-slide mb-card"
            v-for="(item, index) in data.listCouseHot"
            :key="index"
            @click="nextPageDetailsCourse(item)"
            :class="{ disabledCourse: mobile ? index > 3 : index > 9 }"
          >
            <div>
              <!-- Ảnh -->
              <div class="img vaa">
                <template
                  v-if="item.courseCover == null || item.courseCover == ''"
                >
                  <img src="../../../static/images/temppic.jpg" alt="/" />
                </template>
                <template v-else>
                  <template v-if="item.courseCover.match(regExp)">
                    <iframe
                      width="100% !important"
                      height="100% !important"
                      :src="item.courseCover"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    >
                    </iframe>
                  </template>
                  <template v-else>
                    <img :src="item.courseCover" alt="/" />
                  </template>
                </template>
              </div>
              <!-- Tên khoá học -->
              <div class="lessontitle_PC">
                <div class="lessontitle" style="-webkit-box-orient: vertical;">
                  {{ item.courseName }}
                </div>
              </div>
              <div class="startAndPrice">
                <!-- Giá tiền -->
                <div>
                  <span
                    v-if="item.offSelf == 100 || item.coursePrice == 0"
                    class="priceIndex"
                  >
                    <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                  </span>
                  <span v-else class="priceIndex">
                    <template
                      v-if="
                        (item.offSelf > 0 && item.offSelf != null) ||
                          item.offSelf != ''
                      "
                    >
                      <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        (item.coursePrice - item.coursePriceDiscount)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      <del class="price-orin"
                        ><span v-if="beforCurren">{{
                          $t("new.title121")
                        }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></del
                      >
                    </template>
                    <template v-else>
                      <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        item.coursePrice
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                    </template>
                  </span>
                </div>
              </div>
              <!-- Sao đánh giá -->
              <div class="startIndex">
                <div
                  class="Stars"
                  :style="'--rating:' + item.courseEvaluate"
                ></div>
              </div>
              <!-- {{ $t("new.title183") }} -->
              <div>
                <p class="button-sub" @click.stop="clickNextPageSubsribe(item)">
                  {{ $t("new.title183") }}
                </p>
              </div>
              <div class="borderIndex"></div>
              <div
                v-if="
                  (item.offSelf > 0 && item.offSelf != null) ||
                    item.offSelf != ''
                "
                class="hot-position"
              >
                <div class="">
                  <span>-{{ item.offSelf }}%</span>
                </div>
              </div>
            </div>
          </li>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div
          v-if="
            mobile
              ? data.listCouseHot.length > 4
              : data.listCouseHot.length >= 10
          "
          @click="nextPageSelfCourse(2)"
        >
          <p class="mb-read-more">{{ $t("new.title3") }}</p>
        </div>
      </div>
      <!-- DANH SÁCH KHOÁ HỌC MỚI NHẤT CÓ THỂ ĐĂNG KÍ HỌC -->
      <li v-if="data.listCourseNew.length > 0" id="desktop">
        <div class="lessons lessons-new">
          <div class="titles clear">
            <img src="../../../static/images/icon-st.jpg" alt="" />
            <div class="title l">
              <span style="text-transform: uppercase!important;"
                >{{ $t("new.title119") }}
              </span>
              <span
                class="title_more_catalog"
                v-if="
                  mobile
                    ? data.listCourseNew.length > 4
                    : data.listCourseNew.length >= 10
                "
                @click="nextPageSelfCourse(1)"
              >
                <span class="name_more_catalog">{{ $t("new.title3") }}</span>
                <span
                  ><img
                    class="icon_more_catalog"
                    style="height: auto!important;width: 17px!important;cursor: pointer;"
                    src="../../../static/images/dbright.png"
                    alt=""
                /></span>
              </span>
            </div>
          </div>
          <ul class="clear">
            <li
              v-for="(item, index) in data.listCourseNew"
              :key="index"
              @click="nextPageDetailsCourse(item)"
              :class="{ disabledCourse: mobile ? index > 3 : index > 9 }"
            >
              <div>
                <!-- Ảnh -->
                <div class="img vaa">
                  <template
                    v-if="item.courseCover == null || item.courseCover == ''"
                  >
                    <img src="../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="item.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="item.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img :src="item.courseCover" alt="/" />
                    </template>
                  </template>
                </div>
                <!-- Tên khoá học -->
                <div class="lessontitle_PC">
                  <div
                    class="lessontitle"
                    style="-webkit-box-orient: vertical;"
                  >
                    {{ item.courseName }}
                  </div>
                </div>
                <div class="lessontitle_MB">
                  <div
                    class="lessontitle"
                    style="-webkit-box-orient: vertical;"
                  >
                    {{ item.courseName }}
                  </div>
                </div>
                <div class="startAndPrice">
                  <!-- Giá tiền -->
                  <div>
                    <span
                      v-if="item.offSelf == 100 || item.coursePrice == 0"
                      class="priceIndex"
                    >
                      <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                    </span>
                    <span v-else class="priceIndex">
                      <template
                        v-if="
                          (item.offSelf > 0 && item.offSelf != null) ||
                            item.offSelf != ''
                        "
                      >
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          (item.coursePrice - item.coursePriceDiscount)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        <del class="price-orin"
                          ><span v-if="beforCurren">{{
                            $t("new.title121")
                          }}</span>
                          {{
                            item.coursePrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                          <span v-if="afterCurren">{{
                            $t("new.title121")
                          }}</span></del
                        >
                      </template>
                      <template v-else>
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                    </span>
                  </div>
                </div>
                <!-- Sao đánh giá -->
                <div class="startIndex">
                  <div
                    class="Stars"
                    :style="'--rating:' + item.courseEvaluate"
                  ></div>
                </div>
                <!-- {{ $t("new.title183") }} -->
                <div>
                  <p
                    class="button-sub"
                    @click.stop="clickNextPageSubsribe(item)"
                  >
                    {{ $t("new.title183") }}
                  </p>
                </div>
                <div class="borderIndex"></div>
                <div
                  v-if="
                    (item.offSelf > 0 && item.offSelf != null) ||
                      item.offSelf != ''
                  "
                  class="hot-position"
                >
                  <div class="">
                    <span>-{{ item.offSelf }}%</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </li>
      <!-- Swiper New-->
      <div v-if="data.listCourseNew.length > 0" id="mobile">
        <div class="mb-title-item" style="text-transform: uppercase!important;">
          {{ $t("new.title119") }}
        </div>
        <swiper class="swiper" :options="swiperOption">
          <li
            class="swiper-slide mb-card"
            v-for="(item, index) in data.listCourseNew"
            :key="index"
            @click="nextPageDetailsCourse(item)"
            :class="{ disabledCourse: mobile ? index > 3 : index > 9 }"
          >
            <div>
              <!-- Ảnh -->
              <div class="img vaa">
                <template
                  v-if="item.courseCover == null || item.courseCover == ''"
                >
                  <img src="../../../static/images/temppic.jpg" alt="/" />
                </template>
                <template v-else>
                  <template v-if="item.courseCover.match(regExp)">
                    <iframe
                      width="100% !important"
                      height="100% !important"
                      :src="item.courseCover"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    >
                    </iframe>
                  </template>
                  <template v-else>
                    <img :src="item.courseCover" alt="/" />
                  </template>
                </template>
              </div>
              <!-- Tên khoá học -->
              <div class="lessontitle_PC">
                <div class="lessontitle" style="-webkit-box-orient: vertical;">
                  {{ item.courseName }}
                </div>
              </div>
              <div class="startAndPrice">
                <!-- Giá tiền -->
                <div>
                  <span
                    v-if="item.offSelf == 100 || item.coursePrice == 0"
                    class="priceIndex"
                  >
                    <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                  </span>
                  <span v-else class="priceIndex">
                    <template
                      v-if="
                        (item.offSelf > 0 && item.offSelf != null) ||
                          item.offSelf != ''
                      "
                    >
                      <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        (item.coursePrice - item.coursePriceDiscount)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      <del class="price-orin"
                        ><span v-if="beforCurren">{{
                          $t("new.title121")
                        }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></del
                      >
                    </template>
                    <template v-else>
                      <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        item.coursePrice
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                    </template>
                  </span>
                </div>
              </div>
              <!-- Sao đánh giá -->
              <div class="startIndex">
                <div
                  class="Stars"
                  :style="'--rating:' + item.courseEvaluate"
                ></div>
              </div>
              <!-- {{ $t("new.title183") }} -->
              <div>
                <p class="button-sub" @click.stop="clickNextPageSubsribe(item)">
                  {{ $t("new.title183") }}
                </p>
              </div>
              <div class="borderIndex"></div>
              <div
                v-if="
                  (item.offSelf > 0 && item.offSelf != null) ||
                    item.offSelf != ''
                "
                class="hot-position"
              >
                <div class="">
                  <span>-{{ item.offSelf }}%</span>
                </div>
              </div>
            </div>
          </li>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div
          v-if="
            mobile
              ? data.listCourseNew.length > 4
              : data.listCourseNew.length >= 10
          "
          @click="nextPageSelfCourse(1)"
        >
          <p class="mb-read-more">{{ $t("new.title3") }}</p>
        </div>
      </div>
      <!-- DANH SÁCH KHOÁ HỌC ĐƯỢC KHUYẾN KHÍCH BỞI STUDY-ART -->
      <li v-if="data.encourageStudyArt.length > 0" id="desktop">
        <div class="lessons lessons-new">
          <div class="titles clear">
            <img src="../../../static/images/icon-st.jpg" alt="" />
            <div class="title l">
              <span style="text-transform: uppercase!important;"
                >{{ $t("new.title120") }}
              </span>
              <span
                class="title_more_catalog"
                v-if="
                  mobile
                    ? data.encourageStudyArt.length > 4
                    : data.encourageStudyArt.length >= 10
                "
                @click="nextPageSelfCourse(3)"
              >
                <span class="name_more_catalog">{{ $t("new.title3") }}</span>
                <span
                  ><img
                    class="icon_more_catalog"
                    style="height: auto!important;width: 17px!important;cursor: pointer;"
                    src="../../../static/images/dbright.png"
                    alt=""
                /></span>
              </span>
            </div>
          </div>
          <ul class="clear">
            <li
              v-for="(item, index) in data.encourageStudyArt"
              :key="index"
              @click="nextPageDetailsCourse(item)"
              :class="{ disabledCourse: mobile ? index > 3 : index > 9 }"
            >
              <div>
                <!-- Ảnh -->
                <div class="img vaa">
                  <template
                    v-if="item.courseCover == null || item.courseCover == ''"
                  >
                    <img src="../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="item.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="item.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img :src="item.courseCover" alt="/" />
                    </template>
                  </template>
                </div>
                <!-- Tên khoá học -->
                <div class="lessontitle_PC">
                  <div
                    class="lessontitle"
                    style="-webkit-box-orient: vertical;"
                  >
                    {{ item.courseName }}
                  </div>
                </div>
                <div class="lessontitle_MB">
                  <div
                    class="lessontitle"
                    style="-webkit-box-orient: vertical;"
                  >
                    {{ item.courseName }}
                  </div>
                </div>
                <div class="startAndPrice">
                  <!-- Giá tiền -->
                  <div>
                    <span
                      v-if="item.offSelf == 100 || item.coursePrice == 0"
                      class="priceIndex"
                    >
                      <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                    </span>
                    <span v-else class="priceIndex">
                      <template
                        v-if="
                          (item.offSelf > 0 && item.offSelf != null) ||
                            item.offSelf != ''
                        "
                      >
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          (item.coursePrice - item.coursePriceDiscount)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        <del class="price-orin"
                          ><span v-if="beforCurren">{{
                            $t("new.title121")
                          }}</span>
                          {{
                            item.coursePrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}
                          <span v-if="afterCurren">{{
                            $t("new.title121")
                          }}</span></del
                        >
                      </template>
                      <template v-else>
                        <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      </template>
                    </span>
                  </div>
                </div>
                <!-- Sao đánh giá -->
                <div class="startIndex">
                  <div
                    class="Stars"
                    :style="'--rating:' + item.courseEvaluate"
                  ></div>
                </div>
                <!-- {{ $t("new.title183") }} -->
                <div>
                  <p
                    class="button-sub"
                    @click.stop="clickNextPageSubsribe(item)"
                  >
                    {{ $t("new.title183") }}
                  </p>
                </div>
                <div class="borderIndex"></div>
                <div
                  v-if="
                    (item.offSelf > 0 && item.offSelf != null) ||
                      item.offSelf != ''
                  "
                  class="hot-position"
                >
                  <div class="">
                    <span>-{{ item.offSelf }}%</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </li>
      <!-- Swiper Study art-->
      <div v-if="data.encourageStudyArt.length > 0" id="mobile">
        <div class="mb-title-item" style="text-transform: uppercase!important;">
          {{ $t("new.title120") }}
        </div>
        <swiper class="swiper" :options="swiperOption">
          <li
            class="swiper-slide mb-card"
            v-for="(item, index) in data.encourageStudyArt"
            :key="index"
            @click="nextPageDetailsCourse(item)"
            :class="{ disabledCourse: mobile ? index > 3 : index > 9 }"
          >
            <div>
              <!-- Ảnh -->
              <div class="img vaa">
                <template
                  v-if="item.courseCover == null || item.courseCover == ''"
                >
                  <img src="../../../static/images/temppic.jpg" alt="/" />
                </template>
                <template v-else>
                  <template v-if="item.courseCover.match(regExp)">
                    <iframe
                      width="100% !important"
                      height="100% !important"
                      :src="item.courseCover"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    >
                    </iframe>
                  </template>
                  <template v-else>
                    <img :src="item.courseCover" alt="/" />
                  </template>
                </template>
              </div>
              <!-- Tên khoá học -->
              <div class="lessontitle_PC">
                <div class="lessontitle" style="-webkit-box-orient: vertical;">
                  {{ item.courseName }}
                </div>
              </div>
              <div class="startAndPrice">
                <!-- Giá tiền -->
                <div>
                  <span
                    v-if="item.offSelf == 100 || item.coursePrice == 0"
                    class="priceIndex"
                  >
                    <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                  </span>
                  <span v-else class="priceIndex">
                    <template
                      v-if="
                        (item.offSelf > 0 && item.offSelf != null) ||
                          item.offSelf != ''
                      "
                    >
                      <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        (item.coursePrice - item.coursePriceDiscount)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                      <del class="price-orin"
                        ><span v-if="beforCurren">{{
                          $t("new.title121")
                        }}</span>
                        {{
                          item.coursePrice
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></del
                      >
                    </template>
                    <template v-else>
                      <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        item.coursePrice
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                    </template>
                  </span>
                </div>
              </div>
              <!-- Sao đánh giá -->
              <div class="startIndex">
                <div
                  class="Stars"
                  :style="'--rating:' + item.courseEvaluate"
                ></div>
              </div>
              <!-- {{ $t("new.title183") }} -->
              <div>
                <p class="button-sub" @click.stop="clickNextPageSubsribe(item)">
                  {{ $t("new.title183") }}
                </p>
              </div>
              <div class="borderIndex"></div>
              <div
                v-if="
                  (item.offSelf > 0 && item.offSelf != null) ||
                    item.offSelf != ''
                "
                class="hot-position"
              >
                <div class="">
                  <span>-{{ item.offSelf }}%</span>
                </div>
              </div>
            </div>
          </li>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div
          v-if="
            mobile
              ? data.encourageStudyArt.length > 4
              : data.encourageStudyArt.length >= 10
          "
          @click="nextPageSelfCourse(3)"
        >
          <p class="mb-read-more">{{ $t("new.title3") }}</p>
        </div>
      </div>
    </ul>
    <!-- Shopping Cart -->
    <div class="shopping-cart">
      <p class="button-icon" v-if="cart.length > 0" v-on:click="OpenModal()">
        <img src="../../../static/images/Ellipse 5.png" alt="" /><b
          class="total-item-cart"
          >{{ cart.length }}</b
        >
      </p>
      <!-- The Modal -->
      <div id="myModal-Cart" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
          <span v-on:click="CloseModal()" class="close">{{
            $t("new.title208")
          }}</span>
          <div class="cart-content">
            <div v-if="cart.length == 0">
              <img
                class="empty-cart"
                src="../../../static/images/GHtrong2-xanh.png"
                width="150"
                alt="/"
              />
              <!-- <h3 style="text-align:center">{{ $t("new.title152") }} </h3> -->
            </div>
            <table class="cart-table" style="width:100%;">
              <tr
                id="item-course"
                v-for="(carts, index) in cart"
                :key="carts.courseId"
              >
                <td
                  class="item-image"
                  :class="{ cart_moblie: mobile }"
                  style="width:35%;text-align: -webkit-center;"
                >
                  <template
                    v-if="carts.courseCover == null || carts.courseCover == ''"
                  >
                    <img src="../../../static/images/temppic.jpg" alt="/" />
                  </template>
                  <template v-else>
                    <template v-if="carts.courseCover.match(regExp)">
                      <iframe
                        width="100% !important"
                        height="100% !important"
                        :src="carts.courseCover"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      >
                      </iframe>
                    </template>
                    <template v-else>
                      <img :src="carts.courseCover" alt="/" @error="setAltCourse"/>
                    </template>
                  </template>
                </td>
                <td
                  class="item-title"
                  :class="{ cart_moblie: mobile }"
                  style="width:55%"
                >
                  <h3 style="color:#0071c5;line-height:20px;word-break: break-word;">
                    {{ carts.courseName }}
                  </h3>
                  <div style="float:left">
                    <p>{{ $t("new.title145") }}:</p>
                    <p>{{ $t("new.title147") }}:</p>
                    <p v-if="carts.coursePrice >= 0">{{ $t("new.title153") }}:</p>
                  </div>
                  <div style="float:left;padding-left:10px;font-weight:600">
                    <p>{{ carts.timestudy }} {{ $t("new.title146") }}</p>
                    <p>{{ carts.totalless }} {{ $t("new.title154") }}</p>
                    <tempalte v-if="carts.coursePrice>=0">
                        <p v-if="carts.offSelf != 0" class="item-price-cart">
                           <span v-if="beforCurren">{{ $t("new.title121") }}</span
                           >{{
                              (carts.coursePrice - carts.coursePriceDiscount)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                           }}
                           <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        </p>
                        <p v-else class="item-price-cart">
                           <span v-if="beforCurren">{{ $t("new.title121") }}</span
                           >{{
                              carts.coursePrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                           }}
                           <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                        </p>
                    </tempalte>
                  </div>
                </td>
                <td
                  class="item-close"
                  title="bỏ khóa học"
                  style="width:10%"
                  v-on:click="
                    CloseItemCourse(
                      index,
                      carts.coursePrice - carts.coursePriceDiscount
                    )
                  "
                >
                  &#10008;
                </td>
              </tr>

              <tr v-if="cart.length > 0">
                <td colspan="3" class="item-total">
                  <p v-if="reduce>=0">
                    {{ $t("new.title155") }} :
                    <span
                      ><b
                        ><span v-if="beforCurren">{{
                          $t("new.title121")
                        }}</span>
                        {{
                          reduce
                            .toString().replace('.00', '')
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }}
                        <span v-if="afterCurren">{{
                          $t("new.title121")
                        }}</span></b
                      ></span
                    >
                  </p>
                </td>
              </tr>
            </table>

            <button
              v-if="cart.length > 0"
              class="submit"
              @click="NextPageSubsribeCart()"
            >
              {{ $t("new.title143") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import domainName from "../../../env";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      content: true,
      catalog: true,
      related: true,
      dataDetails: {},
      badge: 0,
      data: null,
      afterCurren: false,
      beforCurren: false,
      isMobileFlg: false,
      cartadd: {},
      cart: [],
      reduce: 0,
      detailCourse: [],
      swiperOption: {
        pagination: ".swiper-pagination",
        slidesPerView: "auto",
        paginationClickable: true,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        initialSlide: 1,
        mousewheel: true
      },
      regExp: /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/,
      templateYoutubeSrc: "https://www.youtube.com/embed/",
      domainNameCurrent: window.location.host,
      DOMAIN_NAME: domainName.DOMAIN_NAME_SANRITSU,
    };
  },
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    dataCatatalog: {
      type: Object,
      default: {}
    }
  },
  computed: {
    mobile() {
      return this.$store.getters["header/mobile"];
    }
  },
  async created() {
    this.data = this.dataCatatalog.dataListCatalog;
    // format src type youtube
    this.data.listCouseHot.forEach(el => {
      if (el.courseCover.match(this.regExp)) {
        let temp = el.courseCover.split("https://youtu.be/");
        el.courseCover = this.templateYoutubeSrc + temp[1];
      }
    });
    this.data.listCourseNew.forEach(el => {
      if (el.courseCover.match(this.regExp)) {
        let temp = el.courseCover.split("https://youtu.be/");
        el.courseCover = this.templateYoutubeSrc + temp[1];
      }
    });
    this.data.encourageStudyArt.forEach(el => {
      if (el.courseCover.match(this.regExp)) {
        let temp = el.courseCover.split("https://youtu.be/");
        el.courseCover = this.templateYoutubeSrc + temp[1];
      }
    });
  },
  mounted() {
    this.checkCurren();
    this.viewCart();
    this.init();
  },
  watch: {},
  methods: {
    init() {},
    nextPageSelfCourse(params) {
      // Đi đến menu bán khóa học
      this.$router.push({
        path: "/home/selfCourse",
        query: {
          type: params,
          catalogId: 0
        }
      });
    },
    nextPageDetailsCourse(params) {
      let id = null;
      let listId = [];
      if (params.catalogIds) {
        if (params.catalogIds.length > 0) {
          params.catalogIds.forEach(element => {
            listId.push(element.catalogId);
          });
        }
      }
      let dataUrls = {
        type: 1,
        courseId: params.courseId,
        catalogId: id,
        listId: listId
      };
      // Đi đến chi tiết bán khóa học
      this.$router.push({
        path: "/home/detailsSelfCourse",
        query: {
          outlineInfo: JSON.stringify(dataUrls)
        }
      });
    },
     setAltCourse(event) { 
         event.target.src = "../../../static/images/temppic.jpg" ;
      },
    //
    NextPageSubsribeCart() {
      this.$router.push({
        path: "/home/subscribeSelfCourse",
        query: {}
      });
    },
    // Curency position
    checkCurren() {
      if (this.$lang()) {
        if (this.$lang() == 3 || this.$lang() == 1) {
          this.beforCurren = true;
        } else {
          this.afterCurren = true;
        }
      }
    },
    toggle(value) {
      if (value == "content") {
        this.content = !this.content;
      } else if (value == "related") {
        this.related = !this.related;
      } else {
        this.catalog = !this.catalog;
      }
    },
    OpenModal() {
      document.getElementById("myModal-Cart").style.display = "block";
    },
    CloseModal() {
      document.getElementById("myModal-Cart").style.display = "none";
    },
    CloseItemCourse() {
      document.getElementById("item-course").style.display = "none";
    },
    CloseItemCourse(id, price) {
      this.cart.splice(id, 1);
      if (this.reduce > 0 && price >= 0) {
        this.reduce -= price;
      }
      this.saveCats();
    },
    // Subsribe Course
    clickNextPageSubsribe(item) {
      // Lấy dữ liệu detail
      this.$api
        .post("/evaluate/getDetailsByIdCourse", {
          courseId: item.courseId,
          languageType: this.$lang()
        })
        .then(response => {
          this.detailCourse = response.data;
          // cartadd is here to get all things that click or chosen by user
          const checkUsername = obj => obj.courseId === item.courseId;
          if (this.cart.some(checkUsername) == false) {
            this.cartadd.courseId = item.courseId;
            this.cartadd.courseName = item.courseName;
            this.cartadd.coursePrice = item.coursePrice;
            this.cartadd.courseCover = item.courseCover;
            this.cartadd.timestudy = this.detailCourse.courseEstimatedStudyTime;
            this.cartadd.totalless = this.detailCourse.courseCurriculumTotal;
            this.cartadd.qty = 1;
            this.cartadd.coursePriceDiscount = item.coursePriceDiscount;
            this.cartadd.courseEvaluate = item.courseEvaluate;
            this.cartadd.offSelf = item.offSelf;
            this.cartadd.courseBankInfo = item.courseBankInfo;
            this.cart.push(this.cartadd);
            this.saveCats();
          }
          this.$router.push({
            path: "/home/subscribeSelfCourse",
            query: {}
          });
        })
        .catch(err => {
          // console.log(err.response);
        });
    },
    saveCats() {
      // for save in local storage set the below code
      let parsed = JSON.stringify(this.cart);
      localStorage.setItem("cart_" + this.$lang(), parsed);
      this.viewCart();
    },
    viewCart() {
      if (localStorage.getItem("cart_" + this.$lang())) {
        this.cart = JSON.parse(localStorage.getItem("cart_" + this.$lang()));
        // totall price in shopping cart
        this.reduce = 0;
        for (let index = 0; index < this.cart.length; index++) {
          if (this.cart[index].coursePrice < 0) {
            continue;
          }
          if (this.cart[index].offSelf != 0 && this.cart[index].coursePrice > 0) {
            this.reduce +=
              this.cart[index].coursePrice -
              this.cart[index].coursePriceDiscount;
          } else {
            this.reduce += this.cart[index].coursePrice;
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.Stars {
  --star-size: 20px;
  --star-color: #a8a8a8;
  --star-background: #ff6d35;
  --percent: calc(var(--rating) / 5 * 100%);
  display: inline-block;
  font-size: var(--star-size);
  font-family: Times;
  line-height: 1;
  margin-left: 10px;
  margin-bottom: 5px;
}
.Stars::before {
  content: "★★★★★";
  letter-spacing: 3px;
  background: linear-gradient(
    90deg,
    var(--star-background) var(--percent),
    var(--star-color) var(--percent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.like-ps {
  top: 0px !important;
  left: 2px !important;
}
.primarylists {
  padding-top: 10px;
}
.primarylists > ul > li {
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
  overflow: hidden;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: none !important;
}
.vn .primarylists .lessons ul li > div {
  padding: 0px 0px 15px 0px;
}
.vn .primarylists .lessons ul li {
  margin-bottom: 15px !important;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px;
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
  margin-left: 7px;
}
.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  line-height: 16px !important;
  font-size: 20px;
  padding: 0 0px 0 10px;
  line-height: 35px;
  cursor: unset;
  font-weight: bold;
}
.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}
.more a {
  color: #fff !important;
}
.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}
.primarylists .lessons ul {
  height: auto;
  overflow: hidden;
  transform: translateX(5px);
}
.primarylists .lessons ul li {
  cursor: pointer;
  width: 350px;
  height: auto;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
  border-color: #fff !important;
  /* background-color: #f1f1f1 !important; */
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%) !important;
  border: #dadae8;
}
.primarylists .lessons ul li:hover {
  box-shadow: 0px 0px 20px 0px rgb(0 0 0 / 20%) !important;
}
.primarylists .lessons ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.lessons {
  margin-top: 20px;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 10px 10px 0px 10px !important;
  margin: 5px 0 0px !important;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: #0071c5 !important;
}
.primarylists .lessons .startAndPrice {
  padding: 5px 10px !important;
}
.primarylists .lessons .startAndPrice .priceIndex {
  font-size: 15px;
  font-weight: 600;
  color: #cb0d0d;
}
.price-orin {
  font-size: 13px;
  position: relative;
  bottom: 5px;
  font-weight: 500;
  color: #707070;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
  background: #ff0000 !important;
}
.primarylists .lessons .islike span {
  float: right;
}
.islike div {
  font-size: 12px;
  font-weight: bold;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}
.free-course {
  color: #cb0d0d;
  padding-right: 20px;
}
.title-group {
  padding: 50px 0px 50px 0px !important;
  vertical-align: middle;
}
.title-group img {
  width: 30px;
  height: auto;
  margin: 0px auto;
}
.title-group .title-item {
  padding: 20px 0px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
}
.title-group p {
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  color: #707070;
}
.lessontitle_PC {
  min-height: 60px;
}
.primarylists .lessons.lessons-new ul li {
  width: calc(20% - 16px) !important;
}
.hot-position {
  padding: 5px 10px;
  border-radius: 10px;
  background: #f32b2b;
  color: #fff;
  margin: 10px;
  font-weight: 600;
}
.button-sub {
  text-align: center;
  padding: 5px 20px;
  display: block;
  background-color: #0071c5;
  border-radius: 5px;
  margin: 0 10px;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.button-sub:hover {
  background-color: #02adff !important;
}
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-wrapper {
  padding-left: initial;
  margin: 0;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  width: 80%;
  border-right: 1px solid black;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-pagination {
  position: initial !important;
}
/*     .swiper-slide:nth-child(2n) {
        width: 60%;
    }
    .swiper-slide:nth-child(3n) {
        width: 40%;
    } */
.swiper-container .mb-card {
  height: auto;
  float: left;
  box-sizing: border-box;
  border-color: #fff !important;
  /* background-color: #f1f1f1 !important; */
  -webkit-box-shadow: 0px 1px 7px 1px rgb(0 0 0 / 20%) !important;
  box-shadow: 0px 1px 7px 1px rgb(0 0 0 / 20%) !important;
  border: #dadae8;
  position: relative;
  margin: 5px;
  border-radius: 10px;
  padding-bottom: 5px;
}
.swiper-container .mb-card div {
  padding: 0px 0px 0px 0px;
}
.swiper-container .mb-card img {
  height: 116px !important;
  width: 100% !important;
  overflow: hidden !important;
  border-radius: 4px 4px 0 0;
  object-fit: contain;
}
.swiper-container .mb-card .lessontitle {
  padding: 10px 10px 0px 10px !important;
  margin: 5px 0 0px !important;
  font-size: 15px;
  display: -webkit-box;
  overflow: hidden;
  cursor: pointer !important;
  color: #0071c5 !important;
  -webkit-line-clamp: 2 !important;
  font-weight: bold !important;
  word-break: break-word;
}
.swiper-container .mb-card .startAndPrice .priceIndex {
  font-size: 15px;
  font-weight: 600;
  color: #cb0d0d;
}
.swiper-container .mb-card .hot-position {
  padding: 5px 20px;
  border-radius: 10px;
  background: #f32b2b;
  color: #fff;
  margin: 10px;
  font-weight: 600;
  position: absolute;
}
.mb-title-item {
  color: #0071c5;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
  padding: 15px 0px;
}
.mb-read-more {
  text-align: center;
  padding: 5px 20px;
  border: 1px solid #000;
  width: 150px;
  border-radius: 10px;
  display: block;
  margin: 10px auto;
  font-weight: 600;
  font-size: 15px;
}
.block-rm {
  display: flex;
  justify-content: center;
}
.title-rm {
  display: inline-flex;
}
.icon-rm {
  width: 17px !important;
  height: auto;
}
#mobile {
  display: none;
}
/* check mobile */
@media (max-width: 1112px) {
  .swiper-container {
    display: block !important;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1112px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 820px) {
  .container,
  .bigCourse {
    width: 600px;
  }
  .primarylists .lessons.lessons-new ul li {
    width: calc(33% - 16px) !important;
  }
}
@media screen and (max-width: 600px) {
  .container,
  .bigCourse {
    width: 400px;
  }
  #mobile {
    display: block !important;
  }
  #desktop {
    display: none !important;
  }
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.disabledCourse {
  display: none;
}
.primarylists .lessons .lessontitle_MB {
  display: none;
}
/* style MB */
@media (max-width: 480px) {
  .primarylists .lessons .borderIndex {
    border-bottom: none !important;
  }
  .primarylists .lessons .startAndPrice .priceIndex {
    float: none !important;
  }
  .Stars {
    --star-size: 25px !important;
  }
  .primarylists .lessons .lessontitle {
    padding: 0px 5px 0px 5px !important;
    margin: 0px 0 15px !important;
    height: 35px !important;
  }
  .primarylists .lessons .lessontitle_PC {
    display: none !important;
  }
  .primarylists .lessons .lessontitle_MB {
    display: unset !important;
  }
  .priceIndex {
    padding: 0px 5px 0px 5px !important;
  }
  .startIndex {
    padding: 0px 5px 0px 5px !important;
  }
}
@media screen and (min-width: 481px) and (max-width: 710px) {
  .primarylists .lessons .startAndPrice .priceIndex {
    float: none !important;
  }
}
.container {
  width: 100%;
}

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 3; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 60%;
  border-radius: 10px;
  position: relative;
}

/* The Close Button */
.close {
    color: #fff;
    float: right;
    font-size: 15px;
    font-weight: bold;
    border: 1px solid;
    /* border-color: gray; */
    border-radius: 7px;
    padding: 5px;
    background-color: #25368c;
    cursor: pointer;
    position:absolute;
    right: 5px;
    top: 5px;
}

/* .close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
} */
.modal-content .item-image img {
  width: 100px;
}
.modal-content .item-close {
  font-size: 30px !important;
  cursor: pointer;
  color: #cb0d0d;
}
.modal-content .item-total p {
  font-size: 20px;
  padding: 10px 0px;
  border-top: 1px solid #0071c5;
  text-align: right;
}
.modal-content .item-total span {
  color: #cb0d0d;
}
.modal-content .cart-content .submit {
  padding: 10px 20px;
  background: #0071c5;
  border: none;
  color: #ffff;
  font-size: 20px;
  border-radius: 5px;
  display: block;
  margin: 0px auto;
  cursor: pointer;
}
.modal-content .cart-content .empty-cart {
  display: block;
  margin: 10px auto;
}
.shopping-cart .button-icon {
  position: fixed;
  right: 25px;
  bottom: 10px;
  z-index: 10;
}
.shopping-cart .button-icon img {
  width: 60px;
  cursor: pointer;
}
.shopping-cart .button-icon .total-item-cart {
  background-color: #ffff;
  border: 1px solid #000;
  padding: 5px;
  border-radius: 20px;
  position: absolute;
  right: 40px;
  top: 0px;
  z-index: 1000;
}
.modal-content .cart-content .cart-table td {
  font-size: 16px;
}
.modal-content .cart-content .cart-table td .item-price-cart {
  color: #cb0d0d;
}
/* Price */
.style-1 del {
  color: blue;
  text-decoration: none;
  position: relative;
  font-size: 25px;
  font-weight: 700;
}
.style-1 del ::before {
  content: " ";
  display: block;
  width: 100%;
  border-top: 2px solid #cb0d0d;
  height: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: rotate(-7deg);
}
ins {
  color: #cb0d0d;
  font-size: 35px;
  text-decoration: none;
  padding: 1em 1em 1em 0.5em;
  font-weight: 700;
}
@media only screen and (max-width: 1100px) {
  .flex-container > .media-teacher {
    width: 30%;
  }
  /* Price */
  .style-1 del {
    font-size: 20px;
  }
  ins {
    font-size: 25px;
  }
  .modal-content .cart-content .cart-table td {
    font-size: 16px;
    display: block;
  }
  .modal-content .cart-content .cart-table .item-close {
    width: 10%;
    position: relative;
    top: -85px;
    left: 90%;
    z-index: 1;
  }
}
@media only screen and (max-width: 1200px) {
  .shopping-cart .button-icon {
    position: fixed;
    right: 10px;
    bottom: 60px;
    z-index: 10;
  }
}
@media only screen and (max-width: 600px) {
  .cart-content {
    height: 450px;
    overflow-y: scroll;
  }
  .detail_info-course .box-info span #sub {
    width: 80%;
  }
  /* Modal Content */
  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 90%;
  }
  .modal-content .cart-content .cart-table td {
    display: block;
    font-size: 16px;
  }
  .lesson_content tr td {
    padding: 10px;
    font-size: 14px;
  }
  /* Price */
  .style-1 del {
    font-size: 20px;
  }
  ins {
    font-size: 25px;
  }
}
/* Scroll style */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(96, 183, 241);
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000;
}
.titles .title {
  padding: 0 0px 0 10px;
}
.title_more_catalog {
  float: right;
  display: flex;
}
.name_more_catalog {
  text-transform: none !important;
  cursor: pointer;
  font-size: 12px;
  color: #707070;
}
.cart_moblie {
  width: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/topIndex.vue